// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"95595fc9","389":"71025a2e","455":"2f1a056d","977":"d2261d23"}[chunkId] + ".chunk.js";
};